module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emailreport"
  }, [_c('h1', [_vm._v("Rapporter")]), _vm._v(" "), _c('div', {
    staticClass: "report-inputs-wrapper"
  }, [_c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Ankomst från"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.from),
      expression: "from"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.from = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Ankomst till"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.to),
      expression: "to"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.to = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Kod"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Rader")]), _vm._v(" "), _c('div', {
    staticClass: "checkboxes-container"
  }, _vm._l((_vm.lineTypeOptions), function(option) {
    return _c('label', {
      key: 'line_type' + option.value,
      staticStyle: {
        "font-weight": "normal"
      }
    }, [(option.text !== 'disabled') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.line_types[option.value]),
        expression: "line_types[option.value]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.line_types[option.value]) ? _vm._i(_vm.line_types[option.value], null) > -1 : (_vm.line_types[option.value])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.line_types[option.value],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.line_types, option.value, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.line_types, option.value, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.line_types, option.value, $$c)
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), (option.text !== 'disabled') ? _c('span', [_vm._v(_vm._s(option.text))]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Källa")]), _vm._v(" "), _c('div', {
    staticClass: "checkboxes-container"
  }, _vm._l((_vm.orderSourceOptions), function(option) {
    return _c('label', {
      key: 'order_source' + option.value,
      staticStyle: {
        "font-weight": "normal"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.order_sources[option.value]),
        expression: "order_sources[option.value]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.order_sources[option.value]) ? _vm._i(_vm.order_sources[option.value], null) > -1 : (_vm.order_sources[option.value])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.order_sources[option.value],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.order_sources, option.value, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.order_sources, option.value, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.order_sources, option.value, $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(option.text) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Minst antal dagar"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.days_min),
      expression: "days_min"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.days_min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.days_min = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "report-input-container"
  }, [_c('label', [_vm._v("Max antal dagar"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.days_max),
      expression: "days_max"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.days_max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.days_max = $event.target.value
      }
    }
  }), _c('br')])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help"
  }, [_vm._v("Detta filter funkar inte på alla typer av rader, t.ex. boendetillval")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "report"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.getReportEmailLink()
    },
    on: {
      "click": _vm.showInfo
    }
  }, [_vm._v("Huvud: Epost/tfn")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("Rapporten innehåller e-postadresser och telefonnummer.")])]), _vm._v(" "), _c('div', {
    staticClass: "report"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.getReportEmailExtendedLink()
    },
    on: {
      "click": _vm.showInfo
    }
  }, [_vm._v("Rader: E-post/tfn/mer")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "report"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm.getReportCodesWithExtraInfoLink()
    },
    on: {
      "click": _vm.showInfo
    }
  }, [_vm._v("Huvud: Med kod")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("Rapporten innehåller kundinfo, boende, kod, bokning samt fritextfält för kodbokningar.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "info"
  }, [_vm._v("Rapporten innehåller e-postadresser, telefonnummer, produktkod, pool-ID, antal dagar samt ankomstdatum för "), _c('b', [_vm._v("varje bokningsrad")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6df925c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/EmailReport.vue
// module id = 990
// module chunks = 0